
import Vue from 'vue';
import type { PropOptions } from 'vue';
import type { IPostTopic } from '@/types/community';
import WarRoomTopic from '@/components/partials/war-room/WarRoomTopic/WarRoomTopic.vue';
import { modalNames } from '~/components/partials/war-room/constants';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'WarRoomTopics',
  components: {
    WarRoomTopic,
    BravadoButtonV3,
  },
  props: {
    topics: {
      type: Array,
      required: true,
    } as PropOptions<Array<IPostTopic>>,
  },
  computed: {
    topicsListModalRoute(): Record<string, Record<string, string>> {
      return { query: { dynamic_modal: modalNames.TOPICS_LIST } };
    },
  },
  methods: {
    sendAnalyticEvent(topicName: string) {
      this.$analytics.logEvent('war-room__topics__click', {
        topicName,
      });
    },
  },
});
